mutation SetMerchTestMode($merchOverlayId: ID!, $enabled: Boolean!, $scripted: Boolean) {
  overlay: StreamToolsSetMerchTestMode(
    merchOverlayId: $merchOverlayId
    enabled: $enabled
    scripted: $scripted
  ) {
    merchOverlayId
    merchTestMode
    merchTestScript
    merchTestState
  }
}
